import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaStateService } from '@quorum/sha-media';

@Component({
  selector: 'sha-media-upload-options-dialog',
  templateUrl: './media-upload-options-dialog.component.html',
  styleUrls: ['./media-upload-options-dialog.component.css'],
})
export class MediaUploadOptionsDialogComponent implements OnInit {
  maxCaptionLength = 75;
  mediaOptionsForm = this.fb.group({
    caption: [this.data.caption.substring(0, this.maxCaptionLength)],
    customerFacing: [this.data.customerFacing],
  });
  @Output() uploadClicked = new EventEmitter<any>();
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      caption: string;
      customerFacing: boolean;
    },
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MediaUploadOptionsDialogComponent>,
    public mediaStateService: MediaStateService
  ) {}

  ngOnInit() {}

  upload(formValue: any) {
    this.uploadClicked.emit(formValue);
    this.dialogRef.close();
  }

  closeDialog() {
    console.log('close clicked');
    this.dialogRef.close();
  }

  toggleCustomerFacing(customerFacing: boolean) {
    this.mediaOptionsForm.get('customerFacing').setValue(!customerFacing);
  }
}
